import apiClient from '../apiClient';
import { GET_TEMPLATE_ACCOMODATION_ITEM_DATA_URL } from '../apiUrl';

const getTemplateAccomodationItemApi = () => {
  return apiClient.get(GET_TEMPLATE_ACCOMODATION_ITEM_DATA_URL);
};

export default getTemplateAccomodationItemApi;
